import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentFailure() {
  const navigate = useNavigate();
  const lang = useParams().lang || 'ru';
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 mx-auto text-red-500 mb-4" />
        <h1 className="text-2xl font-bold mb-2">Оплата отменена</h1>
        <p className="text-gray-600 mb-6">
          Ваша корзина сохранена — можно вернуться и попробовать оплатить ещё раз.
        </p>
        <Button
          className="w-full bg-emerald-700 hover:bg-emerald-800"
          onClick={() => navigate(`/${lang}/catalog`)}
          data-testid="back-to-cart-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Вернуться в корзину
        </Button>
      </div>
    </div>
  );
}
